import React, { Fragment } from 'react'
import { Breadcrumb } from 'antd'
import { Link, } from 'react-router-dom'
import HomeHearder from 'src/components/Pages/Home/NewHome/HomeHearder'
import Header4 from 'src/components/Header/Header4'
import { MainBottom } from 'src/components/Pages/Guide/component/index'
import { unitsList } from 'src/components/Pages/Guide/component/Datas/normalDatas'
import { MenuCard } from '../component/index'
import { ResourcesSearchCardList } from '../component/Datas/normalDatas'
import './style.css'
export default function ResourcesSearch(props) {
    const { data } = props;
    return (
        <div className='ResourcesSearch' >
            <div className='ResourcesSearchMain' id='ResourcesSearchMain'>
                <div className='ResourcesSearchTitle'>
                    <Header4 />
                </div>
                <div className='ResourcesSearchMainScroll' >
                    <div className='ResourcesSearchContent'>
                        <div className='ResourcesSearchContentMain'>
                            <div className='ResourcesSearchContentLeft'>
                                <Breadcrumb>
                                    <Breadcrumb.Item >
                                        <Link to='/Guide'>首页</Link>
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item >资源查询</Breadcrumb.Item>
                                </Breadcrumb>
                                <div className='ResourcesSearchContent_Title'>资源查询</div>
                                <div className='ResourcesSearchContent_Introduce'>作为一个新手，如何了解遥感基础知识并且合理使用本网站资源</div>
                                <div className='ResourcesSearchContent_CardList'>
                                    {ResourcesSearchCardList.map((card, index) => {
                                        return (
                                            <div className='ResourcesSearchContent_Card'>
                                                <MenuCard data={card} key={index} />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <MainBottom data={unitsList} />
                </div>
            </div>
        </div>
    )
}